
import React, { createContext, useState, useEffect, useCallback } from 'react';

const ValidationContentLocalStorage = createContext();

export const ValidationContentProvider = ({ children }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedFilePath, setSelectedFilePath] = useState('');
  const [mediaType, setMediaType] = useState('');
  const [programType, setProgramType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [pendingMediaType, setPendingMediaType] = useState('');
  const [language, setLanguage] = useState('');
  const [fileName, setFileName] = useState('');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [dots, setDots] = useState('');
  const [selectedFileObject, setSelectedFileObject] = useState(null);
  // All selected files when several are chosen (selectedFileObject stays the first one)
  const [selectedFileObjects, setSelectedFileObjects] = useState([]);
  const [isCheckingCredits, setIsCheckingCredits] = useState(false);
  const [programId, setProgramId] = useState("");
  const [selectedProgramIds, setSelectedProgramIds] = useState([]);
  // Initialize re-upload target creative from sessionStorage to survive page refresh
  const [revalidateCreative, setRevalidateCreativeState] = useState(() => {
    try {
      const saved = sessionStorage.getItem('mcv_revalidateCreative');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  // Initialize target creative systemId from sessionStorage to survive page refresh
  const [systemId, setSystemIdState] = useState(() => {
    try {
      return sessionStorage.getItem('mcv_systemId') || '';
    } catch {
      return '';
    }
  });
  // Initialize pending validation draft from sessionStorage so unconfirmed re-upload results survive refresh
  const [pendingDraft, setPendingDraftState] = useState(() => {
    try {
      const saved = sessionStorage.getItem('mcv_pendingDraft');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  // Synchronize revalidateCreative updates with sessionStorage
  const setRevalidateCreative = useCallback((valOrFn) => {
    setRevalidateCreativeState((prev) => {
      const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      try {
        if (next) {
          sessionStorage.setItem('mcv_revalidateCreative', JSON.stringify(next));
        } else {
          sessionStorage.removeItem('mcv_revalidateCreative');
        }
      } catch {}
      return next;
    });
  }, []);

  // Synchronize systemId updates with sessionStorage
  const setSystemId = useCallback((valOrFn) => {
    setSystemIdState((prev) => {
      const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      try {
        if (next) {
          sessionStorage.setItem('mcv_systemId', String(next));
        } else {
          sessionStorage.removeItem('mcv_systemId');
        }
      } catch {}
      return next;
    });
  }, []);

  // Synchronize pending validation draft updates with sessionStorage
  const setPendingDraft = useCallback((valOrFn) => {
    setPendingDraftState((prev) => {
      const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      try {
        if (next) {
          sessionStorage.setItem('mcv_pendingDraft', JSON.stringify(next));
        } else {
          sessionStorage.removeItem('mcv_pendingDraft');
        }
      } catch {}
      return next;
    });
  }, []);


  return (
    <ValidationContentLocalStorage.Provider
      value={{
        programs, setPrograms,
        selectedFilePath, setSelectedFilePath,
        mediaType, setMediaType,
        programType, setProgramType,
        alertMessage, setAlertMessage,
        pendingMediaType, setPendingMediaType,
        language, setLanguage,
        fileName, setFileName,
        isAnalyzing, setIsAnalyzing,
        dots, setDots,
        selectedFileObject, setSelectedFileObject,
        selectedFileObjects, setSelectedFileObjects,
        isCheckingCredits, setIsCheckingCredits,
        programId, setProgramId,
        selectedProgramIds, setSelectedProgramIds,
        revalidateCreative, setRevalidateCreative,
        systemId, setSystemId,
        pendingDraft, setPendingDraft,
      }}
    >
      {children}
    </ValidationContentLocalStorage.Provider>
  );
};

export default ValidationContentLocalStorage;
